import { type LocationContent } from "@/components/location-page";
import { FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "caloundra",
  name: "Caloundra",
  title: "Caloundra lawyers and solicitors: wills, probate and property advice",
  metaTitle: `Caloundra Lawyers & Solicitors | ${FIRM.name}`,
  description: `Caloundra solicitors at Golden Beach for wills, probate, powers of attorney, elder law and property advice. Fixed fees, local lawyers. Call ${FIRM.phone}.`,
  lead: "Looking for a solicitor in Caloundra? Our Golden Beach office helps with wills, probate, enduring powers of attorney, elder law and property transactions. We quote before we start, so you know the legal cost before you commit.",
  paragraphs: [
    "Looking for a local lawyer can start with a practical question: is your will still right for your family, who could help if you lost capacity, or what needs to happen after someone dies? Our Golden Beach office helps Caloundra families work through those questions.",
    "A move, retirement or a change in family circumstances can be a useful time to review your will and enduring power of attorney. We discuss your circumstances and explain the scope and cost before you decide to proceed.",
    "If you are buying or selling property, our separate Caloundra conveyancing page sets out contract review, transaction checks and fixed professional fees. This page is the starting point for our wider local legal services.",
  ],
  person: "erin-wilkinson",
  localNotes: [
    {
      t: "Wills and family changes",
      d: "Marriage, separation, new children and changes in assets are reasons to check whether your will still reflects your wishes. Tell us what has changed so we can discuss the advice you need.",
    },
    {
      t: "Enduring powers of attorney",
      d: "Think about who you trust to make decisions, the powers you want to give them and when those powers should begin. We explain the document and discuss your instructions.",
    },
    {
      t: "Probate and estate administration",
      d: "An executor may need help locating the will, identifying assets and liabilities, and deciding whether a court grant is required. Obtaining a grant and administering the whole estate are different scopes of work.",
    },
    {
      t: "Retirement and elder law",
      d: "Downsizing, retirement accommodation and family support arrangements can involve both property and estate-planning decisions. Get advice before signing or transferring assets.",
    },
  ],
  suburbs: [
    "Kings Beach",
    "Moffat Beach",
    "Shelly Beach",
    "Dicky Beach",
    "Currimundi",
    "Little Mountain",
    "Aroona",
    "Battery Hill",
  ],
  faqs: [
    {
      q: "Where can I meet a lawyer serving Caloundra?",
      a: "Contact our Golden Beach office to arrange an appointment. Tell us what you need help with and bring any relevant documents, such as your current will or correspondence about an estate.",
    },
    {
      q: "Can I review my will and enduring power of attorney together?",
      a: "Yes. They serve different purposes, but reviewing them together can help you consider both what happens after your death and who could make decisions during your lifetime.",
    },
    {
      q: "Does every estate need probate?",
      a: "No. The need for a grant depends on the estate's assets, how they are held and the requirements of the organisations holding them. We can discuss whether probate, letters of administration or another approach is relevant.",
    },
    {
      q: "How do I find out the cost of legal advice?",
      a: "Tell us about your matter so we can explain the proposed work, professional fees and any additional charges. Our fee schedule provides a starting point; the scope of your matter determines the quote.",
    },
  ],
};
